import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// TODO: Update based on requirements on it should parse and share data
import { IconButton, makeStyles } from '@material-ui/core';
import { ChatOutlined } from '@material-ui/icons';
import { pxToRem } from '../../../theme';
const useStyles = makeStyles({
    root: {
        '&:hover': {
            background: 'none',
        },
    },
    messageAlert: {
        position: 'absolute',
        top: pxToRem(8),
        right: pxToRem(8),
        width: pxToRem(8),
        height: pxToRem(8),
        borderRadius: '50%',
        backgroundColor: '#A52A2A',
    },
});
export function CellMessage({ isNewMessageAvailable }) {
    const classes = useStyles();
    return (_jsxs(IconButton, { "data-testid": 'data-grid-row-message', disableFocusRipple: true, disableRipple: true, disableTouchRipple: true, className: classes.root, children: [_jsx(ChatOutlined, { color: 'primary' }), isNewMessageAvailable && _jsx("div", { className: classes.messageAlert })] }));
}
